import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { PolicySubType } from 'api/ai-chat/types';
import { DocumentAgentPreviewRouteGuard } from 'components/organisms/agent/document/preview';
import { AgentBuilderRemote } from 'components/pages/agent-builder-remote';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
const ProjectGovernancePolicies = /*#__PURE__*/ lazy(()=>import('components/organisms/project-governance-policies/project-governance-policies').then((m)=>({
            default: m.ProjectGovernancePolicies
        })));
const ProjectGovernancePoliciesContent = /*#__PURE__*/ lazy(()=>import('components/organisms/project-governance-policies/list-main-content').then((m)=>({
            default: m.ProjectGovernancePoliciesContent
        })));
const ProjectGovernancePolicyPage = /*#__PURE__*/ lazy(()=>import('components/organisms/project-governance-policies/policy-create/policy-page').then((m)=>({
            default: m.ProjectGovernancePolicyPage
        })));
const TimesheetPolicies = /*#__PURE__*/ lazy(()=>import('components/pages/timesheet-policies/timesheet-policies').then((m)=>({
            default: m.TimesheetPolicies
        })));
const TimesheetPoliciesContent = /*#__PURE__*/ lazy(()=>import('components/pages/timesheet-policies/list/list-main-content').then((m)=>({
            default: m.TimesheetPoliciesContent
        })));
const PolicyPage = /*#__PURE__*/ lazy(()=>import('components/pages/timesheet-policies/policy-creation/policy-page').then((m)=>({
            default: m.PolicyPage
        })));
/** Feature/RBAC gates for agent-builder pages are bypassed when `AGENT_BUILDER_ACCESS_BYPASS` in `config/environment` is true. */ export const agentBuilderRoutes = [
    {
        path: ROUTE_PATHS.AGENT_BUILDER,
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(AgentBuilderRemote, {})
                })
            },
            {
                path: 'documentation/:documentationAgentId/preview',
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(DocumentAgentPreviewRouteGuard, {})
                })
            },
            {
                path: `${ROUTE_PATHS.TIMESHEET_GOVERNANCE}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "TIMESHEET_POLICIES:READ",
                    children: /*#__PURE__*/ _jsx(TimesheetPolicies, {})
                }),
                children: [
                    {
                        path: `${ROUTE_PATHS.SETTINGS_TIMESHEETS_POLICIES_FLAG_FOR_REVIEW}`,
                        element: /*#__PURE__*/ _jsx(TimesheetPoliciesContent, {
                            policyType: PolicySubType.FlagForReview
                        })
                    },
                    {
                        path: `${ROUTE_PATHS.SETTINGS_TIMESHEETS_POLICIES_BLOCK_CREATION}`,
                        element: /*#__PURE__*/ _jsx(TimesheetPoliciesContent, {
                            policyType: PolicySubType.AutoReject
                        })
                    },
                    {
                        path: `${ROUTE_PATHS.SETTINGS_TIMESHEETS_POLICIES_BLOCK_SUBMISSION}/${ROUTE_PATHS.MATCH_ALL}`,
                        element: /*#__PURE__*/ _jsx(TimesheetPoliciesContent, {
                            policyType: PolicySubType.BlockSubmission
                        })
                    }
                ]
            },
            {
                path: `${ROUTE_PATHS.TIMESHEET_GOVERNANCE}/${ROUTE_PATHS.POLICY_TYPE}/${ROUTE_PATHS.NEW}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "TIMESHEET_POLICIES:CREATE",
                    children: /*#__PURE__*/ _jsx(PolicyPage, {})
                })
            },
            {
                path: `${ROUTE_PATHS.TIMESHEET_GOVERNANCE}/${ROUTE_PATHS.POLICY_TYPE}/${ROUTE_PATHS.POLICY_ID}/${ROUTE_PATHS.EDIT}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "TIMESHEET_POLICIES:WRITE",
                    children: /*#__PURE__*/ _jsx(PolicyPage, {})
                })
            },
            {
                path: `${ROUTE_PATHS.GOVERNANCE_POLICIES}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "PROJECT_GOVERNANCE_POLICIES:READ",
                    children: /*#__PURE__*/ _jsx(ProjectGovernancePolicies, {})
                }),
                children: [
                    {
                        path: `${ROUTE_PATHS.GOVERNANCE_POLICIES_WARN}`,
                        element: /*#__PURE__*/ _jsx(ProjectGovernancePoliciesContent, {
                            policyType: PolicySubType.WarnAndProceed
                        })
                    },
                    {
                        path: `${ROUTE_PATHS.GOVERNANCE_POLICIES_BLOCK}`,
                        element: /*#__PURE__*/ _jsx(ProjectGovernancePoliciesContent, {
                            policyType: PolicySubType.AutoReject
                        })
                    }
                ]
            },
            {
                path: `${ROUTE_PATHS.GOVERNANCE_POLICIES}/${ROUTE_PATHS.POLICY_TYPE}/${ROUTE_PATHS.NEW}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "PROJECT_GOVERNANCE_POLICIES:CREATE",
                    children: /*#__PURE__*/ _jsx(ProjectGovernancePolicyPage, {})
                })
            },
            {
                path: `${ROUTE_PATHS.GOVERNANCE_POLICIES}/${ROUTE_PATHS.POLICY_TYPE}/${ROUTE_PATHS.POLICY_ID}/${ROUTE_PATHS.EDIT}`,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    rule: "PROJECT_GOVERNANCE_POLICIES:WRITE",
                    children: /*#__PURE__*/ _jsx(ProjectGovernancePolicyPage, {})
                })
            },
            {
                path: ROUTE_PATHS.MATCH_ALL,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(AgentBuilderRemote, {})
                })
            }
        ]
    }
];
